<table class="table table-striped webtext-black">
  <thead>
    <tr>
      <th style="width:35%">Recipient of Grant
        <app-st-button-sort-text-asc *ngIf="this.sortedDescRecipientOfGrant" [idVal]="'sort-recipient-of-grant-asc-button-id'" [label]="''" [primary]="false" (click)="this.sortTextRecipientOfGrantName()">

        </app-st-button-sort-text-asc>
        <app-st-button-sort-text-desc *ngIf="!this.sortedDescRecipientOfGrant" [idVal]="'sort-recipient-of-grant-desc-button-id'" [label]="''" [primary]="false" (click)="this.sortTextRecipientOfGrantName()">

        </app-st-button-sort-text-desc>
      </th>
      <th style="width:15%">City
        <app-st-button-sort-text-asc *ngIf="this.sortedDescCity" [idVal]="'sort-city-asc-button-id'" [label]="''" [primary]="false" (click)="this.sortTextCity()">

        </app-st-button-sort-text-asc>
        <app-st-button-sort-text-desc *ngIf="!this.sortedDescCity" [idVal]="'sort-city-desc-button-id'" [label]="''" [primary]="false" (click)="this.sortTextCity()">

        </app-st-button-sort-text-desc>
      </th>
      <th style="width:5%">State</th>
      <th style="width:30%">Donor Name</th>
      <th style="width:15%">Grant Amount
        <app-st-button-sort-number-asc *ngIf="this.sortedDescCashGrantAmt" [idVal]="'sort-cash-grant-amt-asc-button-id'" [label]="''" [primary]="false" (click)="this.sortNumberCashGrantAmt()">

        </app-st-button-sort-number-asc>
        <app-st-button-sort-number-desc *ngIf="!this.sortedDescCashGrantAmt" [idVal]="'sort-cash-grant-amt-desc-button-id'" [label]="''" [primary]="false" (click)="this.sortNumberCashGrantAmt()">

        </app-st-button-sort-number-desc>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let row of rows">
      <td>{{row['recipientOfGrantName']}}&nbsp;<i class="bi bi-search btn" (click)="onViewGrantDetails(row)"></i></td>
      <td>{{row['recipientOfGrantCity']}}</td>
      <td>{{row['recipientOfGrantState']}}</td>
      <td>{{row['donorName']}}</td>
      <td>{{row['cashGrantAmtFormatted']}}</td>
    </tr>
  </tbody>
</table>
